// extracted by mini-css-extract-plugin
export default {"table":"dataTable_table__OXeUw","cell":"dataTable_cell__50DV+","cellHeader":"dataTable_cellHeader__mijEx"};